import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import { CREATE_VOCABULARY_NEW_RECORD, GET_VOCABULARY_NEW_RECORD} from '../actions';

import {
    createVocabularyNewRecordSuccess,
    createVocabularyNewRecordError,
    getVocabularyNewRecordSuccess,
    getVocabularyNewRecordError
} from './actions';
import { getActivityHeadersUpdated } from "../../utils/parentChildActivities";

const CREATE_NEW_RECORD_ERROR = "New record success.";

const createVocabularyNewRecordAsync = async (payload) => {

  
  try{
    if (payload.newRecord.vocabularyRecord.vocabularyId > 0)
    {
      const responseObject = await centralApiAxios.put("vocabularies?id="+ payload.newRecord.vocabularyRecord.vocabularyId, payload.newRecord.vocabularyRecord, getActivityHeadersUpdated(payload));

      return {
      newsItem: responseObject.data,
      vocabularyId: responseObject.data.vocabularyId,
      trashed : payload.newRecord.vocabularyRecord.trashed,
      isNewsItemCreate: !(payload.newRecord.vocabularyRecord.vocabularyId > 0),
      message: ""
      };
    }
    else{
      const responseObject = await centralApiAxios.post("vocabularies?id="+ payload.newRecord.vocabularyRecord.vocabularyId, payload.newRecord.vocabularyRecord, getActivityHeadersUpdated(payload));

      return {
      newsItem: responseObject.data,
      vocabularyId: responseObject.data.vocabularyId,
      trashed : payload.newRecord.vocabularyRecord.trashed,
      isNewsItemCreate: !(payload.newRecord.vocabularyRecord.vocabularyId > 0),
      message: ""
      };
    }

  }
  catch (err) {
    // alert(err);
    return {
       message: CREATE_NEW_RECORD_ERROR,
    };
  }
};

function* createVocabularyNewRecord({ payload }) {
     const { history } = payload;
    try {
      const resultReturned = yield call(createVocabularyNewRecordAsync, payload);
      if (!resultReturned.message) {
        yield put(createVocabularyNewRecordSuccess(resultReturned));
        if (resultReturned.isNewsItemCreate)
        {
            history.push("/app/vocabulary-overview/"+ resultReturned.vocabularyId);
        }
        if (payload.newRecord.vocabularyRecord.trashed == true) {
          history.push("/app/RecordListing/Vocabularies");
          window.location.reload();
        }
        else{
          window.location.reload();
        }
      } else {
        yield put(createVocabularyNewRecordError(resultReturned.message));
      }
    } catch (errorExp) {
      yield put(createVocabularyNewRecordError(CREATE_NEW_RECORD_ERROR));
    }
}

const getVocabularyNewRecordAsync = async (payload) => {
  if (payload.vocabularyId == 0)
  {
    return {
      vocabularyRecord: undefined,
      vocabularyId: 0,
      message: ""
    };
  }
  try{
    const responseObject = await centralApiAxios.get(`/vocabularies/${  payload.vocabularyId}?lcid=1033`);
    return {
    vocabularyRecord: responseObject.data,
    vocabularyId: responseObject.data.vocabularyId,
    message: ""
    };
  }
  catch (err) {
    // alert(err);
    return {
       message: CREATE_NEW_RECORD_ERROR,
    };
  }
};

function* getVocabularyNewRecord({ payload }) {
    // const { history } = payload;
    try {
      const resultReturned = yield call(getVocabularyNewRecordAsync, payload);
      if (!resultReturned.message) {
        yield put(getVocabularyNewRecordSuccess(resultReturned));
      } else {
        yield put(getVocabularyNewRecordError(resultReturned.message));
      }
    } catch (errorExp) {
      yield put(getVocabularyNewRecordError(CREATE_NEW_RECORD_ERROR));
    }
}
// eslint-disable-next-line
export function* watchCreateRecords(newRecord) {
  yield takeEvery(CREATE_VOCABULARY_NEW_RECORD, createVocabularyNewRecord);
}
// eslint-disable-next-line
export function* watchGetVocabularyNewRecord(newRecord) {
  yield takeEvery(GET_VOCABULARY_NEW_RECORD, getVocabularyNewRecord);
}

export default function* rootSaga() {
    yield all([
        fork(watchGetVocabularyNewRecord),
        fork(watchCreateRecords)
    ]);
}
